import React, { Component } from 'react'
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css' // 引入 Quill 的雪主题样式
import * as utils from '@utils'
import { API } from '@const'
import PropTypes from 'prop-types'
import './custom.css';

// 客製字體大小
const fontSizeAttributor = Quill.import('attributors/class/size');
fontSizeAttributor.whitelist = [
  'ft8', 'ft9', 'ft10', 'ft11', 'ft12', "ft14", "ft16", "ft18", "ft20", "ft22", "ft24", "ft26", "ft28", "ft36", "ft48", "ft72"
];
// 客製輸入html
const codeBlockHandler = (quill) => {
  const htmlCode = prompt(`${utils.t('insert')}HTML: `);
  if (htmlCode) {
    quill.clipboard.dangerouslyPasteHTML(0, htmlCode);
  }
};

// 添加工具列
Quill.register(fontSizeAttributor, true);
Quill.register('modules/customToolbar', function (quill, _options) {
  const toolbar = quill.getModule('toolbar');
  toolbar.addHandler('code-block', () => codeBlockHandler(quill));
});


class Editor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      text: '',
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleImageUpload = this.handleImageUpload.bind(this)
  }

  componentDidMount() {
    this.props.onRef(this)
    const toolbar = this.reactQuillRef.getEditor().getModule('toolbar')
    toolbar.addHandler('image', this.handleImageUpload)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  handleChange(value) {
    this.setState({ text: value }, () => {
        if (this.props.handleChange) {
          this.props.handleChange(value)
        }
      }
    )
  }

  handleImageUpload() {
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')
    input.click()
    input.onchange = async () => {
      const file = input.files[0]
      const formData = new FormData()
      formData.append('image', file)
      utils.apiRequest(
        'post',
        API.UPLOAD_IMG,
        formData,
        (response) => {
          const imageUrl = response
          const quill = this.reactQuillRef.getEditor()
          const range = quill.getSelection()
          quill.insertEmbed(range.index, 'image', imageUrl)
        },
        (_error) => { }
      )
    }
  }

  render() {
    return (
      <div>
        <ReactQuill
          ref={(el) => {
            this.reactQuillRef = el
          }}
          modules={{
            toolbar: {
              container: [
                [{ header: ['1', '2', '3', '4', '5', '6'] }, { font: [] }, { size: ['ft8', 'ft9', 'ft10', 'ft11', 'ft12', "ft14", "ft16", "ft18", "ft20", "ft22", "ft24", "ft26", "ft28", "ft36", "ft48", "ft72"] }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ color: [] }, { background: [] }],
                [{ script: 'sub' }, { script: 'super' }],
                [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
                ['link', 'image', 'code-block'],
              ]
            },
            customToolbar: true,
          }}
          formats={[
            'header', 'size', 'font', 'bold', 'italic', 'underline', 'strike',
            'color', 'background', 'script', 'sub', 'super',
            'list', 'bullet', 'indent', 'align', 'direction',
            'link', 'image', 'code-block'
          ]}
          style={{ height: '400px' }}
          value={this.state.text}
          onChange={this.handleChange}
          theme="snow"
        />
      </div>
    )
  }
}

Editor.propTypes = {
  onRef: PropTypes.func,
  handleChange: PropTypes.func,
}

export default Editor
